module.exports = __webpack_public_path__ + "assets/img/029.48d4f739.png";